(() => {
  const popup = document.querySelector('[data-welcome-discount]');
  if (!popup) return;

  const storageKey = 'mimi-welcome-discount-shown-this-session';
  const forcePreview = new URLSearchParams(window.location.search).get('show_welcome_popup') === '1';
  const closeButton = popup.querySelector('[data-welcome-discount-close]');
  const emailInput = popup.querySelector('input[type="email"]');
  const form = popup.querySelector('form');
  const submitted = popup.dataset.submitted === 'true';

  const rememberShown = () => {
    try { sessionStorage.setItem(storageKey, 'true'); } catch (error) {}
  };

  const closePopup = () => {
    popup.removeAttribute('open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('welcome-discount-open');
  };

  const openPopup = () => {
    popup.setAttribute('open', '');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('welcome-discount-open');
    window.setTimeout(() => (submitted ? closeButton : emailInput)?.focus(), 100);
  };

  let shownThisSession = false;
  try {
    shownThisSession = sessionStorage.getItem(storageKey) === 'true';
  } catch (error) {}

  if (submitted) {
    rememberShown();
    openPopup();
  } else if (forcePreview) {
    window.setTimeout(openPopup, 350);
  } else if (!window.Shopify?.designMode && !shownThisSession) {
    rememberShown();
    window.setTimeout(openPopup, 350);
  }

  closeButton?.addEventListener('click', closePopup);
  form?.addEventListener('submit', () => {
    popup.dataset.submitting = 'true';
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.hasAttribute('open')) closePopup();
  });
})();
